import React, { useState } from 'react';
import { PlaySheet } from '../../components/PlaySheet';
import { faHand } from '@fortawesome/free-solid-svg-icons';
import { PlayPrimaryButton } from '../../components/PlayPrimaryButton';
import { useCallJudgeMutation, useSetPlayerStatusMutation } from 'store/services/play/playApi';
import { playErrorMessage } from 'utils/play/playErrors';
import '../Host/HostLobby.css';

/** Decision 16: self-drop with confirmation (Final copy block). */
export const DropSheet: React.FC<{ code: string; tournamentId: string; onClose: () => void }> = ({ code, tournamentId, onClose }) => {
  const [setStatus, { isLoading }] = useSetPlayerStatusMutation();
  const [error, setError] = useState<string | null>(null);
  const drop = async () => {
    setError(null);
    try {
      await setStatus({ id: tournamentId, code, playerId: 'me', action: 'DROP' }).unwrap();
      onClose();
    } catch (err) {
      setError(playErrorMessage(err, "Couldn't drop you from the tournament."));
    }
  };
  return (
    <PlaySheet ariaLabel="Drop from the tournament" onClose={onClose}>
      <h2 className="play-sheet-title">Drop from the tournament?</h2>
      <p className="play-helper">You won't be paired in later rounds. Results you've already played stay on the standings.</p>
      <div className="play-sheet-actions">
        <button type="button" className="play-danger-button" onClick={drop} disabled={isLoading} data-testid="play-drop-confirm">
          Drop me
        </button>
        <button type="button" className="play-secondary-button" onClick={onClose}>
          Keep playing
        </button>
      </div>
      {error && (
        <p className="play-error" role="alert">
          {error}
        </p>
      )}
    </PlaySheet>
  );
};

/** Decision 20: judge call confirm sheet; one open call per match. */
export const JudgeSheet: React.FC<{ code: string; matchId: string; tableNumber: number | null; onClose: () => void }> = ({ code, matchId, tableNumber, onClose }) => {
  const [callJudge, { isLoading }] = useCallJudgeMutation();
  const [error, setError] = useState<string | null>(null);
  const confirm = async () => {
    setError(null);
    try {
      await callJudge({ matchId, code }).unwrap();
      onClose();
    } catch (err) {
      setError(playErrorMessage(err, "Couldn't reach the organizer. Try again."));
    }
  };
  return (
    <PlaySheet ariaLabel="Call a judge" onClose={onClose}>
      <h2 className="play-sheet-title">Call a judge to table {tableNumber ?? '?'}?</h2>
      <p className="play-helper">The organizer gets an alert right away. Pause your game and keep the board as it is.</p>
      <div className="play-sheet-actions">
        <PlayPrimaryButton label="Call a judge" icon={faHand} loading={isLoading} onClick={confirm} />
        <button type="button" className="play-secondary-button" onClick={onClose}>
          Cancel
        </button>
      </div>
      {error && (
        <p className="play-error" role="alert">
          {error}
        </p>
      )}
    </PlaySheet>
  );
};
